import {CategoryCreateDto, CategoryUpdateDto} from "../../../api";
import CategoryModalForm from "../categoryModalForm/categoryModalForm";

export default function CategoryModalFormAddContainer(props: CategoryModalFormAddContainerProps) {
    return <CategoryModalForm
        isModalVisible={props.addFormVisibility}
        setModalVisibility={props.onFinish}
        onSubmit={props.onSubmit}
        modalTitle={props.title}
        saveButtonTitle="Zapisz"
        initialValues={props.CategoryToEdit!}
    />;
}

interface CategoryModalFormAddContainerProps {
    onFinish: (refreshList: boolean) => void,
    onSubmit: (values: CategoryCreateDto | CategoryUpdateDto) => Promise<any>,
    addFormVisibility: boolean,
    title: string,
    CategoryToEdit: CategoryUpdateDto | null
}
